export default __webpack_public_path__ + "3-creatives-will-pitch-to-you.c33b0795.png";